import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MembershipTypes } from '@guryou/core';

// include type subscription for specific provider only
// available only for Studio fitness and Passion Iron
// const getOptions = (t, providerId) => {
//   if (providerId && [260, 976, 1478, 1373, 289, 756].includes(+providerId)) {
//     return [
//       { label: t('GENERAL.service'), value: MembershipTypes.service },
//       { label: t('GENERAL.course/event'), value: MembershipTypes.courseOrEvent },
//       { label: t('GENERAL.subscription'), value: MembershipTypes.subscription },
//     ];
//   }
//   return [
//     { label: t('GENERAL.service'), value: MembershipTypes.service },
//     { label: t('GENERAL.course/event'), value: MembershipTypes.courseOrEvent },
//     // { label: t('GENERAL.video'), value: MembershipTypes.video },
//     // { label: t('GENERAL.workout'), value: MembershipTypes.workout },
//   ];
// };

const useMembershipTypes = () => {
  const [values, setValues] = useState(null);
  const { t } = useTranslation();

  // const providerDetails = useSelector(state => state.provider.generalInfo);
  // const options = getOptions(t, providerDetails?.data?.id);

  // Catalogue → Memberships creates ONLY service and course/event. Subscription
  // and Access memberships are created/managed under Configuration → Membership
  // Rules (see CreateMembershipWithRules).
  const options = [
    { label: t('GENERAL.service'), value: MembershipTypes.service },
    { label: t('GENERAL.course/event'), value: MembershipTypes.courseOrEvent },
  ];

  if (!values) {
    setValues(options);
  }

  return values;
};

export { useMembershipTypes };
